<template>
  <div class="w-full">
    <t-text v-if="title" size="xl" class="pb-2 pl-1 font-semibold">{{ title }}</t-text>
    <div v-if="!hideInputs" class="flex items-center justify-between mt-1 mb-4">
      <div class="w-[116px] pl-1">
        <default-input
          inputType="number"
          label=""
          :value="from"
          :min="minFormatted"
          :max="maxFormatted"
          :step="step"
          :preventAutoFocus="true"
          @change="$emit('change', [parseFloat($event) || minFormatted, value[1]])"
          @focus="$emit('inputFocus')"
          @blur="$emit('inputBlur')"
          inputmode="decimal"
        />
      </div>
      <div class="w-[116px] pr-1">
        <default-input
          inputType="number"
          label=""
          :value="to"
          :min="minFormatted"
          :max="maxFormatted"
          :step="step"
          :preventAutoFocus="true"
          @change="$emit('change', [value[0], parseFloat($event) || maxFormatted])"
          @focus="$emit('inputFocus')"
          @blur="$emit('inputBlur')"
          inputmode="decimal"
        />
      </div>
    </div>
    <div v-else class="flex items-center justify-between mt-2 mb-4">
      <t-text>{{ value[0] }}$</t-text>
      <t-text>{{ value[1] }}$</t-text>
    </div>

    <div class="px-3">
      <VueSlider
        v-if="min >= 0 && max >= 1"
        :min="minFormatted"
        :max="maxFormatted"
        v-model="value_"
        :height="3"
        :dot-size="24"
        :interval="step"
        :enable-cross="false"
        :tooltip="tooltip"
        @change="change"
      >
        <template v-slot:process="{start, end}">
          <div class="bg-silver h-full">
            <div class="absolute top-0 h-full" :style="{'left': `${start}%`, 'width': `${end - start}%`, 'background-color': color}" />
          </div>
        </template>
        <template v-slot:dot="{focus}">
          <div class="w-6 h-6 bg-white border-4 rounded-full" :class="{focus}" :style="{'border-color': color}" />
        </template>
      </VueSlider>
    </div>
  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min'
  import 'vue-slider-component/dist-css/vue-slider-component.css'

  export default {
    name: 'RangeSlider',
    components: {
      VueSlider
    },
    model: {
      event: 'change'
    },
    props: {
      min: {
        type: Number
      },
      max: {
        type: Number
      },
      value: {
        type: Array,
        default: () => [0, 100]
      },
      hideInputs: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: 'none'
      },
      color: {
        type: String,
        default: '#7b7b7b'
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        value_: []
      }
    },
    computed: {
      from() {
        return this.formattedValue[0]
      },
      to() {
        return this.formattedValue[1]
      },
      minFormatted() {
        return this.min > this.max ? this.max : this.min
      },
      maxFormatted() {
        return this.min === this.max ? (this.min || 0) + 1 : this.min > this.max ? this.min : this.max
      },
      step() {
        const diff = this.maxFormatted - this.minFormatted
        const isInt = diff % 1 === 0

        return isInt ? 1 : 0.01
      },
      fractionDigits() {
        return this.step % 1 === 0 ? 0 : 2
      },
      formattedValue() {
        return this.value_.map(v => (+v || 0).toFixed(this.fractionDigits))
      }
    },
    methods: {
      change(v) {
        this.$emit('change', v)
      },
      updateLocalValue(v, isInitial) {
        if (!(v && v.length === 2)) {
          return (this.value_ = [])
        }

        const valueFormatted = isInitial && v[0] === v[1] ? [v[0], (v[0] || 0) + 1] : isInitial && v[0] > v[1] ? [v[1], v[0]] : v
        const valueLimited = [
          valueFormatted[0] < this.minFormatted ? this.minFormatted : valueFormatted[0],
          valueFormatted[1] > this.maxFormatted ? this.maxFormatted : valueFormatted[1]
        ]

        return (this.value_ = valueLimited)
      }
    },
    watch: {
      value(value) {
        this.updateLocalValue(value)
      }
    },
    created() {
      this.updateLocalValue(this.value, true)
    }
  }
</script>
